import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Agent } from '../models/agent';
import { environment } from './../../environments/environment';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { LoginService } from './login.service';

@Injectable({ providedIn: 'root' })
export class AgentService {
  private agentsCache: Agent[] = [];

  constructor(public http: HttpClient, public loginService: LoginService) {}

  addAgent(agent: Agent): Observable<Agent> {
    const url = `${environment.apiUrl}agents`;
    return this.http.post<Agent>(url, agent);
  }

  getAgents(): Observable<Agent[]> {
    if (this.agentsCache.length > 0) {
      return of(this.agentsCache);
    }

    const url = `${environment.apiUrl}agents`;

    var headers = new HttpHeaders();

    console.log(`jwt: ${this.loginService.accessToken}`);

    // auth header now added in interceptor
    // if (this.loginService.accessToken) {
    //   headers = new HttpHeaders({
    //     "authentication": `bearer ${this.loginService.accessToken}`
    //   });
    // }

    return this.http.get<Agent[]>(url, { headers }).pipe(
      tap((agents) => {
        this.agentsCache = agents;
      })
    );

  }

  getAgent(id: string): Observable<Agent> {
    const url = `${environment.apiUrl}agents/${id}`;
    return this.http.get<Agent>(url);
  }
}
